import { useState, useCallback } from 'react'
import { DeleteWarehouseUseCase } from '../../usecases/DeleteWarehouseUseCase'
import { AxiosWarehouseRepository } from '../../infrastructure/AxiosWarehouseRepository'

interface UseDeleteWarehouseResult {
    deleteWarehouse: (warehouseId: string) => Promise<boolean>
    loading: boolean
    error: string | null
    reset: () => void
}

export function useDeleteWarehouse(): UseDeleteWarehouseResult {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const deleteWarehouse = useCallback(
        async (warehouseId: string): Promise<boolean> => {
            setLoading(true)
            setError(null)

            try {
                const repository = new AxiosWarehouseRepository()
                const useCase = new DeleteWarehouseUseCase(repository)

                await useCase.execute(warehouseId)

                setLoading(false)
                return true
            } catch (err) {
                const errorMessage =
                    err instanceof Error
                        ? err.message
                        : 'Error al eliminar el warehouse'
                setError(errorMessage)
                setLoading(false)
                return false
            }
        },
        []
    )

    const reset = useCallback(() => {
        setError(null)
        setLoading(false)
    }, [])

    return {
        deleteWarehouse,
        loading,
        error,
        reset,
    }
}
